import { Component, OnInit } from '@angular/core';
import { getIntParam, movetotop, checkContainesURL } from 'src/app/Shared/commonMethods';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'src/app/Shared/toastr.service';
import { LocationService } from 'src/Services/location.service';
import { Globle } from 'src/app/Shared/global';
import { FormBuilder, FormGroup } from '@angular/forms';
import { filterParameter } from 'src/Models/filterParameter';
import { UniversalService } from 'src/Services/universal.service';
import { EligibilityCheckResponse } from 'src/Models/eligibilityCheckResponseModel';
import { UserType, ProviderUserGroup } from 'src/app/Shared/AppEnums';
import { Title } from '@angular/platform-browser';
import { trimTrailingNulls } from '@angular/compiler/src/render3/view/util';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-eligibility-check-status',
  templateUrl: './eligibility-check-status.component.html',
  styleUrls: ['./eligibility-check-status.component.css']
})
export class EligibilityCheckStatusComponent implements OnInit {
  providerId = 0;
  locations;
  fromProvider = false;
  userType = 0;
  emailTemplateForm: FormGroup;
  model = new filterParameter();
  eligibilityCheckResponse = new EligibilityCheckResponse();

  isDataLoad: boolean = false;
  isRecordFound: boolean = false;
  isloading: boolean = false;
  enrollJSON: any;
  errorModel: any;

  isCustomerIdTextbox: boolean = false;
  isEmailTextbox: boolean = true;

  customerIdTextboxValue: string = '';
  emailTextboxValue: string = '';
  dropdownSettings = {};
  selectedLocation;
  locationDisabled = true;
  locationText = '';
  locationList: any[] = [];

  chkEmail: string = '';

  constructor(
    private universalService: UniversalService,
    private _fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private locationService: LocationService,
    private globle: Globle,
    private titleService: Title,
  ) {
    this.titleService.setTitle('Check Status');
    this.emailTemplateForm = this._fb.group({
      selectLocation: '',
      customerId: '',
      email: '',
      userType: 'Email'
    });
  }

  ngOnInit() {
    this.fromProvider = checkContainesURL(this.router, 'providers');
    this.providerId = getIntParam(this.activatedRoute.params, 'pid');
    this.userType = getIntParam(this.activatedRoute.params, 'usertype');
    this.setProvider();
    this.enableDisable();

    if (this.providerId > 0 && !this.locationDisabled) {
      this.getProviderLocation();
    }
    this.dropdownSettings = {
      singleSelection: true,
      labelKey: "name",
      primaryKey: "id",
      text: "Select location",
      enableSearchFilter: true,
      classes: "dropdownborders",
      noDataLabel: 'No location available',
      showCheckbox: false,
      enableFilterSelectAll: false,
      disabled: this.locationDisabled,
      lazyLoading: true,
      searchBy: ['name']
    };

    this.chkEmail = sessionStorage.getItem('chkEmail');
    if (this.chkEmail != '' && this.chkEmail != null) {
      this.customerIdTextboxValue = this.chkEmail;

      setTimeout(() => {
        this.adminEligibilityCheck(this.emailTemplateForm, 'auto');
      }, 200);

      setTimeout(() => {
        sessionStorage.removeItem('chkEmail');
      }, 1000);
    }
  }

  enableDisable() {
    
    if (this.userType == UserType.Provider) {
      if (this.globle.cUser.userTypeId == ProviderUserGroup.Admin) {
        this.emailTemplateForm.get('selectLocation').disable();
        this.locationDisabled = true;
        this.locationText = this.globle.cUser.locationName;
      }
      else {
        if (this.globle.cUser.userGroupId == 4 || this.globle.cUser.userGroupId == 5) {
          this.emailTemplateForm.get('selectLocation').disable();
          this.locationDisabled = true;
          this.locationText = this.globle.cUser.locationName;
          if (this.globle.cUser.locationId != '0' && this.globle.cUser.locationId != null) {
            this.locationList = [];
            this.locationList.push(this.globle.cUser.locationId);
          }
        }
        else {
          this.emailTemplateForm.get('selectLocation').enable();
          this.locationDisabled = false;
          if (this.globle.cUser.locationId != '0' && this.globle.cUser.locationId != null) {
            this.locationList = [];
            this.locationList.push(this.globle.cUser.locationId);
          }
        }
      }
    }

    if (this.globle.cUser.locationId == '0') {
      this.emailTemplateForm.get('selectLocation').enable();
      this.locationDisabled = false;
    }
  }

  setProvider() {
    if (!this.fromProvider) {
      this.providerId = this.globle.cUser.providerId;
      this.userType = this.globle.cUser.userTypeId
    }
  }

  getProviderLocation(): void {
    this.locationService.getProviderLocationDropdown(this.providerId).subscribe(
      data => {
        this.locations = data;
        if (+this.globle.cUser.locationId > 0)
          this.selectedLocation = this.locations.filter(x => x.id == this.globle.cUser.locationId);
      }
    );
  }

  adminEligibilityCheck(emailTemplateForm: any, actioncall: string) {
    this.enrollJSON = null;
    this.isDataLoad = false;

    if(actioncall == 'button_click'){
      if (this.locationList.length == 0) {
        this.toastr.Error('Please select location', 'Error');
        return;
      }
    }
   
    if (this.isCustomerIdTextbox &&
      (emailTemplateForm.controls['customerId'].value == null || emailTemplateForm.controls['customerId'].value.toString().trim() == '')) {
      this.toastr.Error('Please enter customerid', 'Error');
      return;
    }

    if (this.chkEmail != '' && this.chkEmail != null && actioncall == 'auto') {
      this.model.emailId = this.chkEmail;
    }
    else {
      if (this.isEmailTextbox) {
        if (emailTemplateForm.controls['email'].value.toString().trim() == '') {
          this.toastr.Error('Please enter email', 'Error');
          return;
        }

        if (emailTemplateForm.value['email'].trim() != '') {
          let result = this.isValidMailFormat(emailTemplateForm.controls.email);
          if (result != null) {
            this.toastr.Error('Please provide a valid email', 'Invalid Email');
            return;
          }
        }
        this.model.emailId = emailTemplateForm.controls['email'].value;
      }
      else
        this.model.emailId = '';
    }

    if (this.isCustomerIdTextbox) {
      if (emailTemplateForm.controls['customerId'].value == '') {
        this.toastr.Error('Please enter customer Id', 'Error');
        return;
      }
      this.model.customerId = emailTemplateForm.controls['customerId'].value;
    }

    else
      this.model.customerId = '';
    
    if (this.globle.cUser.userGroupId == 2 || this.globle.cUser.userGroupId == 4 || this.globle.cUser.userGroupId == 5) {
      if (this.globle.cUser.locationId != '0')
        this.model.locationId = this.globle.cUser.locationId;
      else
        this.model.locationId = this.locationList[0];
    }
    else {
      if (this.locationList)
        this.model.locationId = this.locationList[0];
    }

    this.model.isStatusSaveOnDB = 'true';
    this.isloading = true;
    this.universalService.AdminEligibilityCheck(this.model).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          if (data.obj != null) {
            if (data.obj.errorModel != null) {
              this.errorModel = data.obj.errorModel;
            }
          }

          if (data.eligibility['enrollJSON'] != null) {
            this.enrollJSON = JSON.parse(data.eligibility['enrollJSON']);
          }
          this.eligibilityCheckResponse = data.eligibility;
          this.isDataLoad = true;

          this.isRecordFound = true;
        }
        else {
          this.isRecordFound = false;
          this.isDataLoad = true;
        }

      },
      error => {
        this.isloading = false;
      }
    );
  }

  setEliglibityColor(status: any) {

    if (status == 'Complete') {
      return 'clsSuccessEnrollColor';
    }
    else {
      return 'clsErrorEnrollColor';
    }
  }

  setEnrollColor(status: any) {

    if (status == 'Approved') {
      return 'clsSuccessEnrollColor';
    }
    else {
      return 'clsErrorEnrollColor';
    }
  }

  ShowHideTextbox($event) {
    if ($event.currentTarget.value == 'Email') {
      this.isEmailTextbox = true;
      this.isCustomerIdTextbox = false;
      this.customerIdTextboxValue = '';
    }
    else {
      this.isEmailTextbox = false;
      this.isCustomerIdTextbox = true;
      this.emailTextboxValue = '';
    }
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e != element);
  }

  onItemSelect(item: any) {
    this.locationList = [];
    if (this.locationList != undefined) {
      this.locationList = this.removeElemetninArray(this.locationList, item['id']);
    }
    this.locationList.push(item['id']);
  }
  OnItemDeSelect(item: any) {
    this.locationList = [];
    if (this.locationList != undefined) {
      this.locationList = this.removeElemetninArray(this.locationList, item['id']);
    }
  }
  onSelectAll(items: any) {
    this.locationList = [];
    for (let iCounter = 0; iCounter < items.length; iCounter++) {
      this.locationList.push(items[iCounter]['id']);
    }
  }
  onDeSelectAll(items: any) {
    this.locationList = [];
  }

  isValidMailFormat(control: FormControl) {
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if (control.value != '' && (control.value.length <= 5 || !EMAIL_REGEXP.test(control.value))) {
      return { 'Please provide a valid email': true };
    }
    return null;
  }

}
